import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IHocSinhViewShortActionTypes } from "../../action-types/thuc-don/IHocSinhViewShortActionTypes";
import { IHocSinhViewShortReducer } from "../../page-state-model/thuc-don/IHocSinhViewShortReducer";

const iniState: IHocSinhViewShortReducer = {
    status: ePageBaseStatus.is_not_initialization,
    hocSinhs: [],
};

export const hocSinhViewShortReducer = (
    state: IHocSinhViewShortReducer = iniState,
    action: IHocSinhViewShortActionTypes
): IHocSinhViewShortReducer => {
    switch (action.type) {
        case "HOC_SINH_VIEW_SHORT_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading,
            };
        case "HOC_SINH_VIEW_SHORT_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhs: action.payload,
            };
        case "HOC_SINH_VIEW_SHORT_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhs: [],
            };
        default:
            return state;
    }
};
